import { createAdminBondPreviews } from "./AdminBondPreviews";

export const AdminBondPreviewsAll = createAdminBondPreviews("admin_bonds_v2");
